import { useLayoutEffect, useState } from 'react';
const BAR_SLOT_PX = 7;
const MIN_BARS = 24;
const MAX_BARS = 120;
export const DEFAULT_BAR_COUNT = 28;
export default function useWaveformBarCount(ref) {
    const [count, setCount] = useState(DEFAULT_BAR_COUNT);
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const measure = () => {
            const { width } = el.getBoundingClientRect();
            if (width > 0) {
                setCount(Math.max(MIN_BARS, Math.min(MAX_BARS, Math.floor(width / BAR_SLOT_PX))));
            }
        };
        measure();
        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(measure);
            observer.observe(el);
            return () => observer.disconnect();
        }
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [ref]);
    return count;
}
